import "./SideBar.css";
import { useState, useContext } from "react";
import { FunctionButton } from "../../components";
import FormContext from "../../context/FormContext";
import { usePopup } from "../../context/PopupContext";

const useStartOverHandler = (clearFormData) => {
    const { showPopup } = usePopup();

    return () => {
        showPopup("All progress will be lost!", "Are you sure to proceed?", () => {clearFormData(); window.location.reload();});
    };
};

const ProgressBarContainer = ({ children }) => {
    const { clearFormData } = useContext(FormContext);
    const handleStartOver = useStartOverHandler(clearFormData);

    return (
        <div className="progress-bar-container">
            <p>Form Progress</p>
            <div className="nodes-container">
                {children}
            </div>
            <div style={{ textAlign: "center" }}><i>If you would like to start from the beginning, click the button below.</i></div>
            <br></br>
            <FunctionButton label="Clear Form" classNames="important-btn default-btn" onClick={handleStartOver} />
        </div>
    );
};

const ProgressNode = ({ index, listNumber, caption, focused, completed, allowed, setCurrentStep, group = false }) => (
    <div className={`node  fade-in${group ? ' sub-node' : ''}${focused ? ' focused' : ''} ${completed ? ' completed' : 'pending'} ${allowed ? ' allowed' : ''}`}
        onClick={(allowed) ? () => { setCurrentStep(index - 1); } : undefined}>
        {!group &&
            <div className="node-index">{listNumber}.</div>
        }
        <div className="node-label">{caption}</div>
        <div className="node-icon">
            {completed && <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="#1fa513"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M20 6 9 17l-5-5" />
            </svg>}
        </div>
    </div>
);

function MobileProgressBar({ children }) {
    const [isPanelVisible, setIsPanelVisible] = useState(false);
    const { clearFormData } = useContext(FormContext);
    const handleStartOver = useStartOverHandler(clearFormData);

    const toggleSidePanel = () => {
        setIsPanelVisible((prev) => !prev);
    };

    return (
        <div className="mobile-progress-bar">
            <div className={`progress-side-panel-container ${isPanelVisible ? 'show' : 'hide'}`} onClick={toggleSidePanel}>
                <div className={`progress-side-panel ${isPanelVisible ? 'show' : 'hide'}`} onClick={(e) => e.stopPropagation()}>
                    <p className="progress-label"><b>Form Progress</b></p>
                    <div className="nodes-container">
                        {children}
                    </div>
                    <br />
                    <hr></hr>
                    <br />
                    <div style={{ textAlign: "center" }}><i>If you would like to start from the beginning, click the button below.</i></div>
                    <br></br>
                    <FunctionButton label="Clear Form" classNames="important-btn default-btn" onClick={handleStartOver} />
                    <br></br>
                </div>
            </div>

            <button className="progress-button" onClick={toggleSidePanel}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={25}
                    height={25}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#3F3F3F"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <line x1={4} x2={20} y1={12} y2={12} />
                    <line x1={4} x2={20} y1={6} y2={6} />
                    <line x1={4} x2={20} y1={18} y2={18} />
                </svg>
            </button>

        </div>
    );
}


export default function ProgressBar({ steps, currentStep, setCurrentStep, stepCompletion, stepAllowed }) {

    const renderProgressNodes = () => {
        let nodeIndex = 1; // Keep track of sequential index
        let listNumber = 0;

        return steps.map((item, index) => {
            listNumber++;
            if (!item.grouped) {
                // Render a single node for non-grouped items
                return (
                    <ProgressNode
                        key={item.title}
                        index={nodeIndex++}
                        listNumber={listNumber}
                        caption={item.title}
                        focused={currentStep === nodeIndex - 2} // Match with the flattened index
                        completed={stepCompletion[nodeIndex - 2]}
                        setCurrentStep={setCurrentStep}
                        allowed={stepAllowed[nodeIndex - 2]}
                    />
                );
            } else {
                // Render nodes for grouped items
                return (
                    <div className="group-container" key={`group-${index}`}>
                        <div className="group-title">{nodeIndex}. {item.title}</div>
                        {item.content.map((subItem) => (
                            <ProgressNode
                                key={nodeIndex}
                                listNumber={listNumber}
                                index={nodeIndex++}
                                caption={subItem.title}
                                focused={currentStep === nodeIndex - 2}
                                completed={stepCompletion[nodeIndex - 2]}
                                setCurrentStep={setCurrentStep}
                                allowed={stepAllowed[nodeIndex - 2]}
                                group={true}
                            />
                        ))}
                    </div>
                );
            }
        });
    };

    return (
        <>
            <MobileProgressBar>
                {renderProgressNodes()}
            </MobileProgressBar>
            <ProgressBarContainer>
                {renderProgressNodes()}
            </ProgressBarContainer>
        </>
    );
}